import amentities from '../data/amentities.json';

export const AMENITIES = amentities;
